import { Box, Flex, Input } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import { ContentfulTags } from '@enums/ContentfulTags';

const Filters = ({ filters, useFilter, useSearch }) => {
  const [query, setQuery] = useSearch;
  const [selectedFilter, setSelectedFilter] = useFilter;

  const tagToReadable = {
    all: 'All',
    [ContentfulTags.MEDICARE_101]: 'Medicare 101',
    [ContentfulTags.DOES_MEDICARE_COVER]: 'Does Medicare Cover It?',
    [ContentfulTags.FAIR_SQUARE_UPDATES]: 'Fair Square Updates',
  };

  const renderFilters = () => {
    return filters.map((filter, index) => {
      return (
        <Box key={index}>
          <Button
            variant={filter === selectedFilter ? ButtonVariants.primary : ButtonVariants.secondary}
            onClick={() => setSelectedFilter(filter)}
            size="sm"
            minW="100px"
            suppressHydrationWarning // Component depends on Media Query and SSR
          >
            {tagToReadable[filter]}
          </Button>
        </Box>
      );
    });
  };

  return (
    <Box w="100%" display="flex" flexWrap="wrap" gap={[2, 2, 3]} alignItems="center" justifyContent="space-between">
      <Flex flexWrap="wrap" gap={[2, 2, 3]} alignItems="center">
        {renderFilters()}
      </Flex>
      <Box mt={[2, 2, 0]} w={['100%', '100%', 'auto']} flex={1} minW="220px">
        <Input
          borderTop="none"
          borderLeft="none"
          borderRight="none"
          borderRadius={0}
          _placeholder={{ opacity: 1, color: '#999' }}
          borderColor="#999"
          placeholder="Search all posts"
          size="md"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          shadow="none !important"
          w="100%"
        />
      </Box>
    </Box>
  );
};

export default Filters;
